import { render, staticRenderFns } from "./BusinessPreSales.vue?vue&type=template&id=0b5e3de1&scoped=true&"
import script from "./BusinessPreSales.vue?vue&type=script&lang=js&"
export * from "./BusinessPreSales.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPreSales.vue?vue&type=style&index=0&id=0b5e3de1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5e3de1",
  null
  
)

export default component.exports